// Inline stroke icons (currentColor, 1.75 stroke) — no emoji, no icon-font
// dependency. Every icon is decorative (aria-hidden); the control around it
// carries the accessible name.

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
}

/** Crosshair — "show my location". */
export function IconLocate(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="8.25" />
      <circle cx="12" cy="12" r="2.75" fill="currentColor" stroke="none" />
      <path d="M12 1.5v2.75M12 19.75v2.75M22.5 12h-2.75M4.25 12H1.5" />
    </svg>
  )
}

/** Filled navigation arrow pointing up — "map follows my heading". */
export function IconHeading(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 2.75 19.25 20.5 12 16.6 4.75 20.5 12 2.75Z" fill="currentColor" />
    </svg>
  )
}

/** Stopwatch — the parking-duration field. */
export function IconClock(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9.5V13l2.25 2.25M9.5 1.75h5M12 1.75v2.5" />
    </svg>
  )
}

/** Calendar — "when do you arrive". */
export function IconCalendar(props) {
  return (
    <svg {...base} {...props}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M3.5 9.75h17M8 3v4M16 3v4" />
    </svg>
  )
}

/** Magnifier — address search. */
export function IconSearch(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="10.5" cy="10.5" r="7" />
      <path d="m15.75 15.75 5.5 5.5" />
    </svg>
  )
}

/** Pin — a search result / place. */
export function IconPin(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 21.25s-6.75-5.6-6.75-11.25a6.75 6.75 0 0 1 13.5 0c0 5.65-6.75 11.25-6.75 11.25Z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  )
}

/** Navigation arrow — "take me there". */
export function IconNav(props) {
  return (
    <svg {...base} {...props}>
      <path d="M21 3 3.6 10.3c-.9.4-.8 1.7.15 1.95L11 14l1.75 7.25c.25.95 1.55 1.05 1.95.15L21 3Z" />
    </svg>
  )
}

/** Card — "pay for parking". */
export function IconCard(props) {
  return (
    <svg {...base} {...props}>
      <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
      <path d="M2.5 9.75h19M6 14.75h4" />
    </svg>
  )
}

/** Stacked sheets — map layers. */
export function IconLayers(props) {
  return (
    <svg {...base} {...props}>
      <path d="m12 3.25 9 4.75-9 4.75L3 8l9-4.75Z" />
      <path d="m3 12.25 9 4.75 9-4.75M3 16.25 12 21l9-4.75" />
    </svg>
  )
}

/** Compass needle; rotate the svg by -bearing to point north. */
export function IconCompass(props) {
  return (
    <svg {...base} strokeWidth={1.5} {...props}>
      <path d="M12 3 15.2 12H8.8L12 3Z" fill="#e5484d" stroke="#e5484d" />
      <path d="M12 21 8.8 12h6.4L12 21Z" fill="currentColor" stroke="currentColor" opacity=".55" />
    </svg>
  )
}

export function IconPlus(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}

export function IconMinus(props) {
  return (
    <svg {...base} {...props}>
      <path d="M5 12h14" />
    </svg>
  )
}

export function IconClose(props) {
  return (
    <svg {...base} {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  )
}

/** Chevron (points right; rotate via CSS for other directions). */
export function IconChevron(props) {
  return (
    <svg {...base} {...props}>
      <path d="m9 5 7 7-7 7" />
    </svg>
  )
}

/** Side panel toggle. */
export function IconPanel(props) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      <path d="M9.5 4v16" />
    </svg>
  )
}

/** The app mark: a "P" drawn as a path so it stays crisp at any size. */
export function LogoP(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden focusable="false" {...props}>
      <path
        d="M8.75 19V5h4.9a4.6 4.6 0 0 1 0 9.2H8.75"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
